import Backbone from "custom/backbone-bundle";

export default Backbone.View.extend({
  tagName: "block-separator",

  render: function() {
    // no-op: DEPRECATED
  },
});
